import { createApp } from "vue";
import App from "./App.vue";
import "./main.scss";
import "./registerServiceWorker";
import router from "./router";
import { createPinia } from "pinia";
import vuetify from "./vuetify";
import { AXIOS_KEY } from "./utils/constants";
// aXIOSプラグイン
import axiosPlugin from "./plugin/axios";

const pinia = createPinia();
const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(pinia); // Pinia を有効化
app.provide(AXIOS_KEY, axiosPlugin);
app.config.errorHandler = (error, instance, info) => {
  // error: エラーのインスタンス
  // instance: ソースコンポーネント
  // info: なんかの情報

  // errorの情報をもとにハンドリング
  console.log("エラー共通ハンドリング", error);
  console.log("instance", instance);
  console.log("info", info);

  // // (例)エラー画面に遷移
  // router.push("/error");
};
app.mount("#app");
